import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'

import {
  EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN,
  EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_ROLE_SET_ROLES,
  EMPLOYEE_ROLE_SET_ROLE_DETAIL,
  EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS,
  EMPLOYEE_ROLE_SET_ERROR,
  EMPLOYEE_ROLE_IS_SUBMITTING_FORM
} from 'actions/employees/role/constants'

// The initial application state
let initialState = {
  openRightColumn: false,
  currentPage: null,
  totalPage: null,
  roleDetail: null,
  isSubmittingForm: false,
  roles: [],
  assignablePermissions: [],
  error: null
}

// Takes care of changing the application state
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  switch (action.type) {
    case EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case EMPLOYEE_ROLE_SET_ROLES:
      return {...state, roles: action.payload.roles}
    case EMPLOYEE_ROLE_SET_ROLE_DETAIL:
      return {...state, roleDetail: action.payload.role}
    case EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS:
      return {...state, assignablePermissions: action.payload.permissions}
    case EMPLOYEE_ROLE_SET_ERROR:
      return {...state, error: action.payload.error}
    case EMPLOYEE_ROLE_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: action.payload.isSubmittingForm}
    default:
      return {...state}

  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/employees/role.js